export const BEMOB_URL = 'https://www.sweepmob.com/click'
export const BINOM_URL = 'http://tracker.sweepmob.com/c1kgl9k.php?lp=1'
export const BEMOB_URL_Empty = ''
export const AFFISE_URL = 'https://www.sweepmob.com/click?sub3=yvonne.steinert021@gmail.com&sub4=Yvonbe&sub5=Steiner&sub6=02&sub7=12&sub8=1979&city=New+York'
export const EMAIL_VERIFICATION_URL = 'https://emailvalidation.abstractapi.com/v1/?api_key=953207527dc94476a22ceb4e9affceee'